import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { MdFilterAlt } from "react-icons/md";
import { FcClearFilters } from "react-icons/fc";
import Select from "react-select";
import { useState, useEffect } from "react";
import sendRequest from "hooks/useAxios";
import { translateToReactSelect } from "utils/helperFunctions";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import { sendRequestHashtags } from "hooks/useAxios";
import logoGM from "assets/images/sitelogo.svg";

export default function Filter({ filterFunction }) {
  // 0 => order
  // 1 => repair

  //useState
  const [filterData, setFilterData] = useState({
    fname: "",
    lname: "",
    deliverName: "",
    type: "",
    main_status: "",
    mtm_from: "",
    mtm_to: "",
    send_trackingcode: "",
    order_code: "",
    mobile: "",
    // hashtagId: "",
  });
  const [storeList, setStoreList] = useState([]);
  const [hashtagsOption, setHashtagsOption] = useState([]);
  const [filter, setFilter] = useState({});
  const [subGroup, setSubGroup] = useState([]);
  const [flag, setFlag] = useState(false);

  //Function
  const toastCustome = (message) => {
    return toast.custom(
      <div
        className="d-flex  "
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "10px",
        }}
      >
        <div>
          <img style={{ width: "40px" }} src={logoGM}></img>
        </div>
        <div style={{ alignSelf: "center", marginRight: "5px" }}>{message}</div>
      </div>
    );
  };
  const changeHandler2 = (names, values) => {
    setFlag(false);
    setFilter((prev) => {
      return { ...prev, [names]: values };
    });
  };

  const translateProductToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          obj.id = arrayValue[index].id;
        } else {
          obj.txt = arrayValue[index].label;
          obj.id = arrayValue[index].value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].txt;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }
    return after;
  };
  const translateHashtags = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].hashtag.id) {
          obj.id = arrayValue[index].hashtag.id;
        } else {
          obj.txt = arrayValue[index].hashtag.label;
          obj.id = arrayValue[index].hashtag.value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue?.length; index++) {
        let obj = {};
        {
          arrayValue[index].hashtag.title
            ? (obj.label = arrayValue[index].hashtag.title)
            : (obj.label = arrayValue[index].hashtag.txt);
        }
        obj.value = arrayValue[index].hashtag.id;

        after.push(obj);
      }
    }
    return after;
  };

  const translateProductToReactSelectHashtag = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].hashtags_id) {
          obj.id = arrayValue[index].hashtags_id;
        } else {
          obj.txt = arrayValue[index].label;
          obj.id = arrayValue[index].value;
        }

        after.push(obj.hashtags_id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].txt;
        obj.value = arrayValue[index].hashtags_id;

        after.push(obj);
      }
    }
    return after;
  };
  const filterIdToObject = (array, id) => {
    return array.filter((a) => a.value == id);
  };
  const validation = () => {
    let valid = false;
    if (
      filter.subGroupId &&
      filter.subGroupId != "" &&
      filter.buy &&
      filter.buy != "" &&
      filter.cityId &&
      filter.cityId != "" &&
      filter.hashtagId &&
      filter.hashtagId != "" &&
      filter.productId &&
      filter.productId != ""
    ) {
      valid = true;
    }
    return valid;
  };

  //useEffect
  useEffect(() => {
    sendRequest("Find_businesses").then(({ data }) => {
      setStoreList([
        ...data.map((value) => {
          return {
            value: value.id,
            label: value.title,
            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    });
    sendRequestHashtags("get_main_hashtag").then((data) => {
      setHashtagsOption(translateHashtags(data.data.data, false));
    });
  }, []);
  console.log("d", storeList);

  const changeHandler = (value, type) => {
    setFilterData((prev) => {
      return { ...prev, [type]: value };
    });
  };

  return (
    <div className=" d-flex order-item2 mx-4 mt-5 p-4">
      <div>
        <form className="form row w-100">
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2 ">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="nameUser"
                style={{
                  color: "#707070",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                }}
              >
                نام :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="nameUser"
                name="fName"
                value={filterData.fname}
                onChange={(e) => {
                  changeHandler(e.target.value, "fname");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2 ">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="deliverName"
                style={{
                  color: "#707070",
                  whiteSpace: "nowrap",
                  fontSize: "15px",
                }}
              >
                نام خانوادگی :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="deliverName"
                name="fName"
                value={filterData.lname}
                onChange={(e) => {
                  changeHandler(e.target.value, "lname");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="DateReceived"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                تاریخ دریافت از :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <div style={{ direction: "rtl" }}>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  inputClass={"date-picker-style form-control"}
                  calendarPosition="bottom-right"
                  id="DateReceived"
                  name="DateReceived"
                  value={filterData.mtm_from}
                  onChange={(value) => {
                    changeHandler(value, "mtm_from");
                  }}
                />
              </div>
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="upTo"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                تاریخ دریافت تا:
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <div style={{ direction: "rtl" }}>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  inputClass={"date-picker-style form-control"}
                  calendarPosition="bottom-right"
                  id="upTo"
                  name="upTo"
                  value={filterData.mtm_to}
                  onChange={(value) => {
                    changeHandler(value, "mtm_to");
                  }}
                />
              </div>
            </div>
          </div>
          {/* <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="type"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                نوع :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <select
                id="type"
                name="type"
                className="form-control form-select"
                value={filterData.type}
                onChange={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, type: e.target.value };
                  });
                }}
              >
                <option value={0}>سفارش</option>
                <option value={1}> تعمیر</option>
              </select>
            </div>
          </div> */}
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="status"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                وضعیت :
              </label>
            </div>
            <div className="input" id="status" style={{ width: "50%" }}>
              <select
                id="status"
                name="status"
                className="form-control form-select"
                value={filterData.main_status}
                onChange={(e) => {
                  changeHandler(e.target.value, "main_status");
                }}
              >
                <option value="0">ثبت شده</option>
                <option value="1"> تکمیل شده</option>
                <option value="2">لغو شده</option>
                {/* <option value={3}>درحال تست</option> */}
              </select>

              {/* {filterData.type == 0 ? (
                <select
                  id="status"
                  name="status"
                  className="form-control form-select"
                  value={filterData.status}
                  onChange={e => {
                    changeHandler(e.target.value, "status");
                  }}
                >
                  <option value={0}>ثبت شده</option>
                  <option value={1}> پرداخت شده</option>
                  <option value={2}>پردازش شده </option>
                  <option value={3}>ارسال شده </option>
                </select>
              ) : (
                <select
                  id="status"
                  name="status"
                  className="form-control form-select"
                  value={filterData.status}
                  onChange={e => {
                    changeHandler(e.target.value, "status");
                  }}
                >
                 
                  <option value={0}>دریافت کالا ودر انتظار برسی</option>
                  <option value={1}> درحال برسی</option>
                  <option value={2}>در حال تعمیر</option>
                  <option value={3}>درحال تست</option>
                  <option value={4}>اماده ی تحویل</option>
                </select>
              )} */}
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="tracking"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                شماره پیگیری :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                name="tracking"
                // required
                className="form-control"
                id="tracking"
                value={filterData.send_trackingcode}
                onChange={(e) => {
                  // if (!isNaN(e.target.value))
                  changeHandler(e.target.value, "send_trackingcode");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="orderNumber"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                شماره سفارش :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="orderNumber"
                name="orderNumber"
                value={filterData.order_code}
                onChange={(e) => {
                  if (!isNaN(e.target.value))
                    changeHandler(e.target.value, "order_code");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="numberM"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                موبایل :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="numberM"
                name="numberM"
                value={filterData.mobile}
                onChange={(e) => {
                  if (!isNaN(e.target.value))
                    changeHandler(e.target.value, "mobile");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="storeList"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                فروشگاه :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <Select
                id="storeList"
                options={storeList}
                placeholder="انتخاب..."
                value={filterIdToObject(storeList, filterData.business_id)}
                onChange={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, business_id: `${e.value}` };
                  });
                }}
              ></Select>
            </div>
          </div>{" "}
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label w-50">
              <label
                htmlFor="category"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                گروه کالایی :
              </label>
            </div>
            <div className="input w-50">
              <Select
                //className="form-control  search-input  "
                aria-label="Username"
                aria-describedby="basic-addon1"
                options={hashtagsOption}
                onChange={(e) => {
                  setFilterData({
                    hashtags_id: "-1",
                  });
                  changeHandler2("hashtagId", e.value);
                  changeHandler2("hashtags_id", -1);
                  filter.subGroupId && changeHandler2("subGroupId", "");
                  sendRequestHashtags("get_sub_hashtag", {
                    hashtag_id: `${e.value}`,
                    // tbl_name: "Inner Join,hashtags,hashtag_id,id",
                    // conditions: `hashtags_links.parent_id/=/${e.value}  `,
                  }).then((data) => {
                    setSubGroup(
                      translateProductToReactSelect(data.data.data, false)
                    );
                  });
                }}
                value={filterIdToObject(hashtagsOption, filter.hashtagId)}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label w-50">
              <label
                htmlFor="category"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                زیرگروه کالایی :
              </label>
            </div>
            <div className="input w-50">
              <Select
                //   type="text"
                //className="form-control  search-input "

                aria-label="Username"
                aria-describedby="basic-addon1"
                options={subGroup}
                onChange={(e) => {
                  setFilterData((prev) => {
                    // return { ...prev, hashtag_id: `${subGroup.hashtag_id}` };
                    return { ...prev, hashtags_id: e.value };
                  });
                }}
                // onChange={(e) => {
                //   changeHandler2("subGroupId", e.value);
                // }}
                value={filterIdToObject(subGroup, filterData.hashtags_id)}
              />
            </div>
          </div>{" "}
          <div className="box-btn col-12 d-flex align-items-center justify-content-end mt-3">
            <div className="">
              <button
                style={{
                  marginLeft: "5px",

                  backgroundColor: "#457b9d",
                  color: "white",
                  border: "none",
                  borderRadius: "15px",
                  padding: "8px 20px ",
                  fontSize: "18px",
                }}
                type="button"
                onClick={() => {
                  console.log("hashtagdid", filter.hashtagId);
                  console.log("zitgroh", filterData.hashtags_id);
                  console.log({
                    con1: !filterData.hashtags_id,
                    con2: filterData.hashtags_id == -1,
                  });
                  // return filterFunction(
                  //   {
                  //     ...filterData,
                  //     mtm_from: filterData.mtm_from && filterData.mtm_from.unix,

                  //     mtm_to: filterData.mtm_to && filterData.mtm_to.unix,
                  //   },
                  //   "1"
                  // );
                  {
                    filter.hashtagId &&
                    (!filterData.hashtags_id || filterData.hashtags_id == -1)
                      ? toastCustome("زیرگروه کالایی واردکنید")
                      : filterFunction(
                          // filterData,
                          {
                            ...filterData,
                            mtm_from:
                              filterData.mtm_from && filterData.mtm_from.unix,

                            mtm_to: filterData.mtm_to && filterData.mtm_to.unix,
                          },
                          "1"
                        );
                  }
                }}
              >
                جستجو
                <MdFilterAlt></MdFilterAlt>
              </button>
            </div>
            <div className="">
              <button
                className="bg-danger"
                style={{
                  marginLeft: "10px",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  padding: "8px 20px ",
                  fontSize: "18px",
                }}
                type="button"
                onClick={() => {
                  filterFunction(filterData, "0");
                  setFilterData((prev) => {
                    return {
                      ...prev,
                      fname: "",
                      lname: "",
                      mtm_from: "",
                      mtm_to: "",
                      send_trackingcode: "",
                      order_code: "",
                      mobile: "",
                      hashtags_id: "",
                      business_id: "",
                      // hashtagId: "",
                      main_status: "",
                    };
                  });
                  setFilter((prev) => {
                    return {
                      ...prev,
                      hashtagId: "",
                    };
                  });
                }}
              >
                حذف جستجو
                <MdFilterAlt></MdFilterAlt>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
